*,
*::before,
*::after {
  box-sizing: border-box;
}

:host {
  display: inline-block;
}

:host([disabled]) {
  cursor: not-allowed;
  opacity: 0.4;
}

.context-menu-anchor {
  display: contents;
}
